import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import useIsMounted from './useIsMounted';
function isTouchDevice(): boolean {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || 'msMaxTouchPoints' in navigator && (navigator as {
    msMaxTouchPoints: number;
  }).msMaxTouchPoints > 0;
}
function useIsTouchDevice() {
  const $ = _c(2);
  const mounted = useIsMounted();
  let t0;
  if ($[0] !== mounted) {
    t0 = mounted ? isTouchDevice() : null;
    $[0] = mounted;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default useIsTouchDevice;